import Footer from './Footer'

import './locales'

export default Footer
export { default as CookiePreferences } from './components/CookiePreferences'
export { default as CFFooter } from './CFFooter/CFFooter'
